<template>
    <div id="setting-crm" ref="settingCRM">
        <vs-sidebar static-position hidden-background :parent="$refs.parentSidebar" :default-index="indexSelected" color="primary"
                    class="sidebarx rounded-md"
                    spacer style="height: calc(var(--vh, 1vh) * 100 - 166px)">
            <vs-sidebar-group title="Cài đặt" open>
                <vs-sidebar-item index="1" icon="style" @click="selectItem(1)">
                    Hạng thẻ
                </vs-sidebar-item>
<!--                <vs-sidebar-item index="2" icon="palette" @click="selectItem(2)">-->
<!--                    Tên, logo, màu-->
<!--                </vs-sidebar-item>-->
                <vs-sidebar-item index="3" icon="settings_phone" @click="selectItem(3)">
                    Tổng đài
                </vs-sidebar-item>
                <vs-sidebar-item index="4" icon="tune" @click="selectItem(4)">
                    Pancake
                </vs-sidebar-item>
                <vs-sidebar-item index="5" icon="accessibility" @click="selectItem(5)">
                    Seeder
                </vs-sidebar-item>
            </vs-sidebar-group>
        </vs-sidebar>

        <div class="screen-data pl-2">
            <CardClassManage v-if="indexSelected === 1"></CardClassManage>
<!--            <LogoAndColorKey v-if="indexSelected === 2"></LogoAndColorKey>-->
            <ConfigTelecom v-if="indexSelected === 3"></ConfigTelecom>
            <PancakeToken v-if="indexSelected === 4"></PancakeToken>
            <PancakeSeeder v-if="indexSelected === 5"></PancakeSeeder>
        </div>
    </div>
</template>

<script>
import CardClassManage from "./card-class/CardClassManage";
// import LogoAndColorKey from "../logo-and-color-key/LogoAndColorKey";
import ConfigTelecom from "@/views/user-pages/crm-module/setting-crm/config-tele/ConfigTelecom";
import PancakeToken from "@/views/user-pages/crm-module/setting-crm/config-pancake/PancakeToken";
import PancakeSeeder from "@/views/user-pages/crm-module/setting-crm/config-pancake/PancakeSeeder";

export default {
    name: "SettingCRM",
    components: {
        CardClassManage,
        // LogoAndColorKey,
        ConfigTelecom,
        PancakeToken,
        PancakeSeeder,
    },
    data() {
        return {
            indexSelected: 1,
        }
    },

    methods: {
        selectItem(evt) {
            this.indexSelected = evt;
        }
    }
}
</script>

<style lang="scss">
#setting-crm {
    overflow: hidden;
    position: relative;
    display: flex;

    .vs-content-sidebar {
        width: 260px;
    }

    .screen-data {
        width: calc(100% - 260px);;
    }

    h4 {
        width: 100%;
        font-size: 15px;
    }

    a {
        font-size: 15px;
    }

    .vs-sidebar--item i.material-icons {
        font-size: 15px;
    }

    .vs-sidebar--items {
        border-radius: 0.5rem;
    }
}
</style>
